import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductLineupSection from './components/ProductLineupSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import SchoolSupportSection from './components/SchoolSupportSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { useSEO, generateOrganizationSchema } from '../../utils/seoUtils';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://ids-group.jp';

  const seoData = {
    title: 'IDS教習所グループ｜農業ドローン・自動操舵システム・水管理システム販売｜佐賀・福岡・鹿児島',
    description: '佐賀県多久市・佐賀市・鹿児島県日置市でDJI農業ドローン（AGRAS T70P/T25P/T25/T10・Mavic 3M）、FJD・EFIX自動操舵システム、Farmo水管理システムを販売。農業ドローン協議会認定スクール運営。最短2日で資格取得、購入後も安心の地域密着サポート。点検整備・散布代行対応。無料相談受付中。',
    keywords: 'IDS教習所グループ,農業ドローン,DJI AGRAS,AGRAS T70P,AGRAS T25P,AGRAS T25,AGRAS T10,Mavic 3M,FJDynamics,EFIX,自動操舵システム,Farmo,水管理システム,農業ドローン協議会,ドローンスクール,佐賀県,多久市,佐賀市,鹿児島県,日置市,RTK測位,精密農業,スマート農業,散布代行,点検整備,資格取得',
    canonical: `${siteUrl}/`,
    structuredData: {
      "@context": "https://schema.org",
      "@graph": [
        generateOrganizationSchema(),
        {
          "@type": "WebSite",
          "name": "IDS教習所グループ",
          "url": `${siteUrl}/`,
          "description": "佐賀・福岡・鹿児島でDJI農業ドローン、FJD・EFIX自動操舵システム、Farmo水管理システムを販売。農業ドローン協議会認定スクール運営。",
          "publisher": {
            "@type": "Organization",
            "name": "IDS教習所グループ"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${siteUrl}/?s={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        }
      ]
    }
  };

  useSEO(seoData);

  useEffect(() => {
    const h1 = document.createElement('h1');
    h1.textContent = 'IDS教習所グループ';
    h1.style.position = 'absolute';
    h1.style.left = '-9999px';
    h1.style.fontSize = '1px';
    document.body.appendChild(h1);

    return () => {
      if (document.body.contains(h1)) {
        document.body.removeChild(h1);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProductLineupSection />
        <CaseStudiesSection />
        <WhyChooseUsSection />
        <SchoolSupportSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
